module.exports = __webpack_public_path__ + "img/Color S109.083576f2.jpg";